import { NextSeo } from 'next-seo';

const PrivacyPolicy = () => {
  return (
    <>
      <NextSeo
        title="Privacy Policy | PrishaPolicy"
        description="This website (https://www.prishapolicy.com/) is owned by Prisha Insurance Brokers Private Limited (PrishaPolicy). Protecting your privacy and treating the personal information of all users of our website in accordance with the law is very important to us. PrishaPolicy understands that by using our website you may be entrusting us with personal information, and we value the users who access the website at any time and assure you that we take our duty to protect and safeguard this information very seriously."
      />
      <div>
        <div className="my-15 container py-12 px-4 text-center">
          <h1 className="heading-6 text-left font-semibold">PRIVACY POLICY</h1>
          <p className="mt-6 text-left">
            Dear Customer, <br />
            This website (https://www.prishapolicy.com/) is owned by Prisha Insurance Brokers Private Limited
            (PrishaPolicy). Protecting your privacy and treating the personal information of all users of our website in
            accordance with the law is very important to us. PrishaPolicy understands that by using our website you may
            be entrusting us with personal information, and we value the users who access the website at any time and
            assure you that we take our duty to protect and safeguard this information very seriously.
            <br />
            <br />
            This Privacy Policy which is framed in accordance with the requirements of the Information Technology
            (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011
            (Information Security Rules 2011). This Privacy Policy describes Personal Information which may be collected
            by us and provides our approach towards handling, dealing and using with the same. The following is included
            in this Policy:
            <br />
            <ol className="list-decimal p-[20px]">
              <li> What Personal Information we collect</li>
              <li>Collection of Personal information</li>
              <li>Purpose for which we use Personal Information</li>
              <li>Sharing of Personal Information</li>
            </ol>
            <br />
            <br />
            By using and continuing to use the Site of PrishaPolicy you are deemed to have consented to the terms of or
            Privacy Policy.
          </p>

          <br />
          <br />
          <h1 className="heading-6 text-left font-semibold">WHAT PERSONAL INFORMATION WE COLLECT</h1>

          <p className="mt-6 text-left">
            <b>“Personal Information” </b>refers to and includes any and all the information that identifies or can be
            used to identify, contact, to whom such information pertains to, including, but not limited to, name, email
            address and mobile number and other such related information. The personal information that we collect about
            you may include Name, Email Address and Mobile Number and/or any other information as provided by you on
            need-to-need basis.
            <br />
            <br />
            PrishaPolicy shall collect and store the personal information of each user, as may be provided by him in any
            form on the website. This Personal Information of each user as defined above may be collected and stored
            automatically by this Website.
          </p>
          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">COLLECTION OF PERSONAL INFORMATION</h1>

          <p className="mt-6 text-left">
            PrishaPolicy may collect your Personal Information when you use the Site and services or during the course
            of our relationship as and when you interact with us. the Personal Information may be collected by
            PrishaPolicy through its website or through any of its authorized third party. Third party may be any
            service provider who is authorized by PrishaPolicy to store, gather, manage process and protect the
            information on its behalf.
            <br />
            <br />
            PrishaPolicy may also collect and hold information relating to your use of our services which may include
            your browsing history on our website and our additional information provided by you while using our Site. A
            log of your activities on our Site may be kept by using various internet techniques such as cookies, server
            files etc., for analytical purpose.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">PURPOSE FOR WHICH WE USE PERSONAL INFORMATION</h1>

          <p className="mt-6 text-left">
            We use and process customer’s Personal Information for a range of purposes, which may include:
            <ol className="list-decimal p-[20px]">
              <li> To contact customers for clarifications on their requirements and expectations</li>
              <li>To fulfill requests made to us</li>
              <li>To deliver administrative notices or relevant alerts</li>
              <li>
                To verify the identity and suitability of customers for certain prTo verify the identity and suitability
                of customers for certain products and servicesoducts and services
              </li>

              <li>To detect, prevent and investigate fraud</li>
              <li>To comply with applicable laws, rules and regulations.</li>
              <li>
                To perform internal business processes such as data analysis, audits, developing and improving new
                products and services.{' '}
              </li>
              <li>To share blogs and newsletters with the customers.</li>
            </ol>
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">SHARING OF PERSONAL INFORMATION</h1>

          <p className="mt-6 text-left">
            <b>Internal Use:</b> PrishaPolicy may utilize all available Personal Information for internal assessment,
            measures, operations and related activities or any other lawful purposes.
            <br />
            <br />
            <b>Related Third Party:</b> PrishaPolicy may also share the Personal Information collected with related
            third parties for the purpose the Personal Information is collected.
            <br />
            <br />
            PrishaPolicy may transfer, share the personal Information collected from you to fulfil the terms of contract
            they have with related parties, only to provide better services to you. While sharing personal information
            with third parties, adequate safety measures will be taken by PrishaPolicy to safeguard the Personal
            Information so collected.
            <br />
            <br />
            <b>Government Agencies:</b> We may share Personal Information of the user with the Government agencies
            mandated under the law to obtain personal information including sensitive personal data or information for
            the purposes of verification of identify or for prevention, detection, investigation including cyber
            incidents, prosecution and punishment of offences.
            <br />
            <br />
            Our website has links to other website(s) in the World Wide Web. The privacy policy of these website(s) is
            not under our control. Once you leave our server, use of any information you provide in governed by the
            privacy policy of the operator of the site you are visiting. In its advisable to read their privacy policies
            for further information.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">COOKIES</h1>

          <p className="mt-6 text-left">
            These are small pieces of information saved by the User’s browser on his computer automatically. Cookies are
            used to track the websites usually visited by the user and to assist the Company to provide you with
            uninterrupted service by understanding the products of User’s interest.
            <br />
            <br />
            PrishaPolicy further does not use or provide any personal information of any user collected/ complied
            through cookies to any third party for any purpose except for preparation of any statistics, data
            compilation, surveys etc. in such case the Company undertakes that not to disclose any personal information
            of any user with the third party.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">NOTICE OF CHANGE</h1>

          <p className="mt-6 text-left">
            The Company may at any time in its sole discretion amend this Privacy Policy. The applicable version is
            always the current one
            <br />
            <br />
            By using this website, the User signifies his agreement to the terms of this privacy policy.
          </p>

          <br />
          <br />

          <h1 className="heading-6 text-left font-semibold">FEEDBACK AND CONCERNS</h1>

          <p className="mt-6 text-left">
            PrishaPolicy is committed to safeguard and handle your Personal information with utmost diligence and we
            therefore, look forward to your continued support for the same. In case of any concerns or feedback
            regarding the protection or safety issues of your Personal Information, you may contact us at{' '}
            <b>info@prishapolicy.com</b>.
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
